module.exports = __webpack_public_path__ + "img/5.ffc5eac4.jpg";